import React from 'react'
import { Collapse } from '@mui/material'
import NumberField from '../../shared/NumberField'
import {
  useWatch,
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../..'

interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues?: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}
const RestaurantsCount = (props: Props) => {
  const { control, resetField } = props

  const watch = useWatch({ control, name: 'property.extras.restaurant' })
  const condition = watch === 'restaurant'

  React.useEffect(() => {
    if (!condition) {
      resetField('property.numberOfRestaurants', { defaultValue: '' })
    }
  }, [condition, resetField])

  return (
    <Collapse in={condition}>
      <NumberField
        title="createPropertyAdFields.numberOfRestaurants.label"
        titleProps={{ required: false }}
        translateTitle
        control={control}
        name={'property.numberOfRestaurants' as Path<FormValues>}
      />
    </Collapse>
  )
}

export default RestaurantsCount
